import { useCallback, useEffect } from 'react';

import { subscribeToEmergencyCallDetailsEvents } from './useEmergencyCallDetailsEventSubscriptions';

import { useAppDispatch } from 'features/app/hooks';
import { ParticipantsStatusEventBus } from 'features/call/call-status/services';
import { EmergencyCallDetailsStatus } from 'features/emergency/enums';
import { setEmergencyCallDetailsStatus } from 'features/emergency/store';
import { useWhileComponentMounted } from 'features/utils/hook';

export function useEmergencyCallDetailsStatusHandler() {
  const whileComponentMounted = useWhileComponentMounted();
  const dispatch = useAppDispatch();

  const handleStatusCalleeConnected = useCallback(() => {
    dispatch(
      setEmergencyCallDetailsStatus(EmergencyCallDetailsStatus.CALLEE_CONNECTED)
    );
  }, [dispatch]);

  const handleStatusCalleeReconnect = useCallback(() => {
    dispatch(
      setEmergencyCallDetailsStatus(EmergencyCallDetailsStatus.CALLEE_RECONNECT)
    );
  }, [dispatch]);

  useEffect(() => {
    const subscriptions = subscribeToEmergencyCallDetailsEvents(
      [
        {
          event$: ParticipantsStatusEventBus.hearing.$connecting,
          handler: handleStatusCalleeConnected,
        },
        {
          event$: ParticipantsStatusEventBus.hearing.$connected,
          handler: handleStatusCalleeConnected,
        },
        {
          event$: ParticipantsStatusEventBus.hearing.$disconnected,
          handler: handleStatusCalleeReconnect,
        },
      ],
      whileComponentMounted
    );

    return () =>
      subscriptions.forEach((subscription) => subscription.unsubscribe());
  }, [
    handleStatusCalleeConnected,
    handleStatusCalleeReconnect,
    whileComponentMounted,
  ]);
}
